import classNames from 'classnames'
import { Image } from 'components/Image'

function PlayButtonBackground({ onClick, className, fontSize = 40 }) {
  return (
    <div
      className={classNames(
        'flex flex-col justify-center items-center w-full h-full relative text-white text-[40px] z-3 [&_img]:cursor-pointer',
        className
      )}
      onClick={() => onClick?.()}
    >
      <Image alt={'Play Button'} height={fontSize} src="/play-btn.svg" width={fontSize} />
    </div>
  )
}

export { PlayButtonBackground }
